import { ProjectDtoRelV2 } from '../../../commonTypes/project.types';
import { formatToMonthDayYear } from '../../../util/date/dateFormater';
import { PremiumTooltip } from '../../../components/Common/PremiumTooltip';
import cc from 'classcat';

interface ProjectCardProps {
    project: ProjectDtoRelV2;
    statusColor: string;
    onDragStart: (e: React.DragEvent<HTMLDivElement>, projectId: string) => void;
    onViewDetails: (projectId: string) => void;
    isDisabled?: boolean;
    showPremiumTooltip?: boolean;
}

export const ProjectCard = ({
    project,
    statusColor,
    onDragStart,
    onViewDetails,
    isDisabled = false,
    showPremiumTooltip = false,
}: ProjectCardProps) => {
    const handleDragStart = (e: React.DragEvent<HTMLDivElement>) => {
        if (isDisabled) {
            e.preventDefault();
            return;
        }
        onDragStart(e, project.id);
    };

    const handleClick = () => {
        if (!isDisabled) {
            onViewDetails(project.id);
        }
    };

    return (
        <div
            className={cc(['project-card', isDisabled && 'project-card--disabled', isDisabled && showPremiumTooltip && 'premium-tooltip-wrapper'])}
            draggable={!isDisabled}
            onDragStart={handleDragStart}
            onClick={handleClick}
            style={{ backgroundColor: `${statusColor}0F`, position: 'relative' }}
        >
            <div className="project-card__header">
                <h4 className={cc(['project-card__title', isDisabled && 'project-card__title--disabled'])} style={{ borderColor: `${statusColor}` }}>
                    {project.name}
                </h4>
            </div>
            <div className="project-card__content">
                <p className={cc(['project-card__date', isDisabled && 'project-card__date--disabled'])}>{project.clientName || '-'}</p>
                <p className={cc(['project-card__date', isDisabled && 'project-card__date--disabled'])}>
                    {project.startDate ? formatToMonthDayYear(project.startDate) : '-'}
                </p>
            </div>
            {isDisabled && showPremiumTooltip && <PremiumTooltip position="top" showOnHover />}
        </div>
    );
};
